import { InlineStack, Text } from "@shopify/polaris";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSubjectEntityHref, getSubjectTypeLabel } from "./audit-subject-registry";

type Props = {
  companyId: string;
  subjectType: string;
  subjectId: string | null;
  subjectName?: string | null;
  /** Precise route from metadata if available */
  clientRoute?: string;
  /** when false, skip "Open" link (e.g. you are already on the entity page) */
  showOpenLink?: boolean;
};

export function AuditSubjectLine({
  companyId,
  subjectType,
  subjectId,
  subjectName,
  clientRoute,
  showOpenLink = true,
}: Props) {
  const { t } = useTranslation();
  const label = getSubjectTypeLabel(t, subjectType);
  
  // Prefer the exact clientRoute stored in metadata if it exists and showOpenLink is true
  const href = showOpenLink
    ? clientRoute || getSubjectEntityHref(subjectType, companyId, subjectId)
    : null;

  const displayName = subjectName || subjectId;
  return (
    <InlineStack gap="200" blockAlign="center" wrap>
      <Text as="span" variant="bodySm" fontWeight="semibold">
        {label}
      </Text>
      {displayName && (
        <Text as="span" variant="bodySm" fontWeight="medium" breakWord>
          {String(displayName)}
        </Text>
      )}
      {href && (
        <Text as="span" variant="bodySm">
          <Link to={href} style={{ textDecoration: "underline" }}>
            {t("audit_open_entity", { defaultValue: "Open" })}
          </Link>
        </Text>
      )}
    </InlineStack>
  );
}
